<div class="btn-group"
    [class.me-3]="rightOffset"
    role="group"
    aria-label="Button group with nested dropdown"
    *ngIf="!dropdownOnly && actionsList?.length && user && user.role && user.role.name && roles && (user|roleAny:roles)"
>
    <ng-container *ngFor="let action of actionsList | slice:0:dropdownStartFrom">
        <a  *ngIf="action?.link && user && user.role && user.role.name"
            [routerLink]="action?.link"
            [queryParams]="action?.queryParams"
            class="btn btn-primary"
            [class.highlight]="action?.highlight"
            [class.btn-sm]="smallButtons"
            [class.disabled]="action?.disabled"
            [attr.title]="action?.tooltip"
            (click)="$event?.stopPropagation()"
        >
            <ng-container [ngTemplateOutlet]="templateOrText" [ngTemplateOutletContext]="{item: action, responsiveText: true}"></ng-container>
        </a>

        <a  *ngIf="action?.external_link && user && user.role && user.role.name"
            target="_blank"
            [href]="action?.external_link"
            class="btn btn-primary"
            [class.highlight]="action?.highlight"
            [class.btn-sm]="smallButtons"
            [class.disabled]="action?.disabled"
            [attr.title]="action?.tooltip"
            (click)="$event?.stopPropagation()"
        >
            <ng-container [ngTemplateOutlet]="templateOrText" [ngTemplateOutletContext]="{item: action, responsiveText: true}"></ng-container>
        </a>

        <button *ngIf="!action?.link && !action?.external_link && !action?.file && user && user.role && user.role.name"
                type="button"
                (click)="onButtonClicked($event, action?.id ?? action?.text ?? '')"
                class="btn btn-primary"
                [class.highlight]="action?.highlight"
                [class.btn-sm]="smallButtons"
                [class.disabled]="action?.disabled"
                [attr.disabled]="action?.disabled ? true : null"
                [attr.title]="action?.tooltip"
        >
            <ng-container [ngTemplateOutlet]="templateOrText" [ngTemplateOutletContext]="{item: action, responsiveText: true}"></ng-container>
        </button>

        <upload *ngIf="action && action?.file && !action?.link && !action?.external_link && action?.text && !action?.header"
                [type]="action?.file ?? 'file'"
                [files]="1"
                [chunkSize]="30*1024"
                [label]="'Избор на файл' | transloco"
                [labelUploading]="'Качване...' | transloco"
                [disabled]="action?.disabled ?? false"
                class="btn btn-primary p-0 btn-in-group"
                (onFileStarted)="onUploadHandle(action?.id ?? action?.text ?? '', 'onFileStarted', $event)"
                (onFileUploaded)="onUploadHandle(action?.id ?? action?.text ?? '', 'onFileUploaded', $event)"
                (onFileProgress)="onUploadHandle(action?.id ?? action?.text ?? '', 'onFileProgress', $event)"
                (onFileError)="onUploadHandle(action?.id ?? action?.text ?? '', 'onFileError', $event)"
                (onFilesStarted)="onUploadHandle(action?.id ?? action?.text ?? '', 'onFilesStarted', $event)"
                (onFilesFinished)="onUploadHandle(action?.id ?? action?.text ?? '', 'onFilesFinished', $event)"
        >
            <ng-template itemTemplate="default" let-isButtonHover>
                <div class="dropdown-item upload-item text-start" [class.hover]="isButtonHover">
                    <ng-container [ngTemplateOutlet]="templateOrText" [ngTemplateOutletContext]="{item: action, responsiveText: true}"></ng-container>
                </div>
            </ng-template>
        </upload>

    </ng-container>

    <div class="btn-group" role="group" *ngIf="(actionsList?.length ?? 0) > dropdownStartFrom">
        <ng-container   [ngTemplateOutlet]="dropdown"
                        [ngTemplateOutletContext]="{actions: actionsList | slice:dropdownStartFrom, user: user}">
        </ng-container>
    </div>
</div>

<ng-container   *ngIf="dropdownOnly && (!user || !user.role || !roles || (user|roleAny:roles))"
                [ngTemplateOutlet]="dropdown"
                [ngTemplateOutletContext]="{actions: actionsList, user: user}">
</ng-container>

<ng-template #dropdown  let-actions="actions" let-user="user">
    <button #dropdownButton
            type="button"
            class="btn {{ dropdownClass }} dropdown-toggle"
            [class.btn-sm]="smallButtons"
            data-bs-toggle="dropdown"
            aria-expanded="false"
            (click)="onDropdownButton($event, dropdownButton)"
    >
        <i *ngIf="dropdownIcon?.length" class="fa-solid fa-fw fa-lg" [ngClass]="dropdownIcon"></i>

        {{ dropdownButtonText }}
    </button>
    <ul class="dropdown-menu">
        <ng-container *ngFor="let action of actions; let last = last">
            <li *ngIf="!action?.hide">
                <a  *ngIf="action?.link"
                    [routerLink]="action?.link"
                    [queryParams]="action?.queryParams"
                    class="dropdown-item btn btn-primary btn-sm rounded-0"
                    [class.disabled]="action?.disabled"
                    [attr.title]="action?.tooltip"
                    (click)="$event?.stopPropagation()"
                >
                    <ng-container [ngTemplateOutlet]="templateOrText" [ngTemplateOutletContext]="{item: action}"></ng-container>
                </a>

                <a  *ngIf="action?.external_link"
                    target="_blank"
                    [href]="action?.external_link"
                    class="dropdown-item btn btn-primary btn-sm rounded-0"
                    [class.disabled]="action?.disabled"
                    [attr.title]="action?.tooltip"
                    (click)="$event?.stopPropagation()"
                >
                    <ng-container [ngTemplateOutlet]="templateOrText" [ngTemplateOutletContext]="{item: action}"></ng-container>
                </a>

                <button *ngIf="!action?.file && !action?.link && !action?.external_link && action?.text && !action?.header"
                        class="dropdown-item btn btn-primary btn-sm rounded-0"
                        (click)="onButtonClicked($event, action?.id ?? action?.text ?? '')"
                        [class.disabled]="action?.disabled"
                        [attr.disabled]="action?.disabled ? true : null"
                        type="button"
                        [attr.title]="action?.tooltip"

                >
                    <ng-container [ngTemplateOutlet]="templateOrText" [ngTemplateOutletContext]="{item: action}"></ng-container>
                </button>

                <upload *ngIf="action?.file && !action?.link && !action?.external_link && action?.text && !action?.header"
                        class="btn btn-default p-0 w-100 rounded-0 border-0"
                        [type]="action?.file ?? 'file'"
                        [files]="1"
                        [chunkSize]="30*1024"
                        [label]="'Избор на файл' | transloco"
                        [labelUploading]="'Качване...' | transloco"
                        [disabled]="action?.disabled ?? false"
                        (onFileStarted)="onUploadHandle(action?.id ?? action?.text ?? '', 'onFileStarted', $event)"
                        (onFileUploaded)="onUploadHandle(action?.id ?? action?.text ?? '', 'onFileUploaded', $event)"
                        (onFileProgress)="onUploadHandle(action?.id ?? action?.text ?? '', 'onFileProgress', $event)"
                        (onFileError)="onUploadHandle(action?.id ?? action?.text ?? '', 'onFileError', $event)"
                        (onFilesStarted)="onUploadHandle(action?.id ?? action?.text ?? '', 'onFilesStarted', $event)"
                        (onFilesFinished)="onUploadHandle(action?.id ?? action?.text ?? '', 'onFilesFinished', $event)"
                >
                    <ng-template itemTemplate="default" let-isButtonHover>
                        <div class="dropdown-item upload-item text-start" [class.hover]="isButtonHover">
                            <ng-container [ngTemplateOutlet]="templateOrText" [ngTemplateOutletContext]="{item: action}"></ng-container>
                        </div>
                    </ng-template>
                </upload>

                <hr *ngIf="action?.divider" class="dropdown-divider">

                <span *ngIf="action?.header" class="dropdown-header">
                    {{ action?.text }}
                </span>
            </li>
        </ng-container>
    </ul>
</ng-template>

<ng-template #templateOrText let-item="item" let-responsiveText="responsiveText">

    <ng-container *ngIf="item.template && (templatesList?.[item.template] ?? false); else textItem">
        <ng-container *ngTemplateOutlet="templatesList[item.template]"></ng-container>
    </ng-container>
    <ng-template #textItem>
        <i [class]="(item?.icon || defaultEmptyIcon) + ' fa-fw me-1'"></i>

        <span *ngIf="responsiveText" class="d-none d-md-inline"> {{ item?.text ?? '' }} </span>
        <ng-container *ngIf="!responsiveText">{{ item?.text ?? '' }}</ng-container>
    </ng-template>

</ng-template>
